import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_ISSUES, LOADING_ISSUES } from './mutations';
import api from '@/api';

const buildIssuesActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getIssues = buildIssuesActionObject('getIssues');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getIssues.action]({ commit }, payload) {
		const { page, filterBy = {} } = payload || {};
		commit(LOADING_ISSUES, true);
		try {
			const data = await api.getIssues(page, filterBy);
			const allIssues = [];
			for (const flowIssues of data.results) {
				const flowData = flowIssues.flow_data;
				const totalRuns = flowIssues.total_runs;
				for (const error of flowIssues.errors) {
					allIssues.push({ ...error, flow_data: flowData, totalRuns });
				}
			}
			allIssues.sort((a, b) => new Date(b.last_occurrence) - new Date(a.last_occurrence));
			commit(SET_ISSUES, allIssues);
			return { results: allIssues, hasNextPage: data.hasNextPage, count: data.count }; // TODO: when BE is ready, return data directly
		} finally {
			commit(LOADING_ISSUES, false);
		}
	},
};

export default actions;
